import { Component, input, output } from '@angular/core';

import { ConflictInfo } from 'src/app/services/event-conflict.service';

@Component({
  selector: 'app-event-conflict-warning',
  imports: [],
  template: `
    <div
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4"
      (click)="onBackdropClick($event)"
    >
      <div
        class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full p-6"
        (click)="$event.stopPropagation()"
      >
        <!-- Header -->
        <div class="flex items-start gap-3 mb-4">
          <div
            class="flex-shrink-0 w-10 h-10 bg-orange-100 dark:bg-orange-900/30 rounded-full flex items-center justify-center text-xl"
          >
            ⚠️
          </div>
          <div>
            <h2 class="text-lg font-bold text-gray-900 dark:text-white">
              Conflit de créneau détecté
            </h2>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
              {{
                conflicts().length > 1
                  ? conflicts().length + ' événements'
                  : 'Un événement'
              }}
              déjà prévu sur ce créneau
            </p>
          </div>
        </div>

        <!-- Liste des conflits -->
        <div class="space-y-2 mb-5">
          @for (c of conflicts(); track c) {
            <div
              class="flex items-start gap-3 p-3 rounded-xl border border-orange-200 dark:border-orange-800 bg-orange-50 dark:bg-orange-900/20"
            >
              <span class="text-orange-500 text-lg flex-shrink-0">📅</span>
              <div class="min-w-0">
                <p class="font-semibold text-gray-800 dark:text-gray-100 truncate">
                  {{ c.event.name }}
                </p>
                <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                  @if (c.reason === 'overlap') {
                    Chevauchement horaire
                  }
                  @if (c.reason === 'too-close') {
                    Moins d'1h entre les deux événements
                    @if (c.gap != null) {
                      <span>({{ c.gap }}min de battement)</span>
                    }
                  }
                </p>
              </div>
            </div>
          }
        </div>

        <p class="text-sm text-gray-600 dark:text-gray-400 mb-5">
          Vous pouvez tout de même ajouter cet événement, mais vérifiez que vous
          pouvez être présent sur les deux créneaux.
        </p>

        <!-- Actions -->
        <div class="flex gap-3">
          <button
            (click)="cancel.emit()"
            class="flex-1 px-4 py-2.5 rounded-xl border border-gray-300 dark:border-slate-600 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 transition"
          >
            Annuler
          </button>
          <button
            (click)="confirm.emit()"
            class="flex-1 px-4 py-2.5 rounded-xl bg-orange-500 text-white text-sm font-semibold hover:bg-orange-600 transition"
          >
            Ajouter quand même
          </button>
        </div>
      </div>
    </div>
  `,
})
export class EventConflictWarningComponent {
  readonly conflicts = input<ConflictInfo[]>([]);
  readonly confirm = output<void>();
  readonly cancel = output<void>();

  onBackdropClick(e: MouseEvent): void {
    this.cancel.emit();
  }
}
